import { render, staticRenderFns } from "./TrainingAccordion.vue?vue&type=template&id=008fa2fd&"
import script from "./TrainingAccordion.vue?vue&type=script&lang=js&"
export * from "./TrainingAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports